import request from '@/utils/request';

/**
 * @param {*} parm 我的页面
 * @returns
 */
// 用户获取用户收款信息列表
export function getUserBankList(parm) {
  return request({
    url: '/user/userbank/list',
    method: 'post',
    data: parm,
  });
}
// 删除某条用户收款信息
export function deleteUserBank(parm) {
  return request({
    url: '/user/userbank/remove',
    method: 'post',
    data: parm,
  });
}
// 获取系统银行配置列表
export function getSysBankList(parm) {
  return request({
    url: '/user/userbank/sysbanklist',
    method: 'post',
    data: parm,
  });
}
// 用户新增收款信息
export function saveUserBank(parm) {
  return request({
    url: '/user/userbank/save',
    method: 'post',
    data: parm,
  });
}
// 获取成交信息
export function getTransInfo(parm) {
  return request({
    url: '/user/userinfo/gettransinfo',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 获取流水记录
export function getRecordList(parm) {
  return request({
    url: '/user/userbalance/recordlist',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 获取冻结详情列表
export function getLockList(parm) {
  return request({
    url: '/user/userbalance/locklist',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 修改用户信息
export function userinfoUpdate(parm) {
  return request({
    url: '/user/userinfo/update',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 获取国家信息
export function getCountryInfo(parm) {
  return request({
    url: '/user/userinfo/getcountryinfo',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 获取验证码(需手动输入账号)
export function sendValidCode(parm) {
  return request({
    url: '/user/userinfo/sendvalidcode',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户绑定手机号或者邮箱
export function updateBindInfo(parm) {
  return request({
    url: '/user/userinfo/bindinfo',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户修改绑定手机号或者邮箱的验证
export function modifyBindVerify(parm) {
  return request({
    url: '/user/userinfo/modifybindverify',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户修改绑定手机号或者邮箱
export function modifyBindInfo(parm) {
  return request({
    url: '/user/userinfo/modifybindinfo',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户获取免密支付额度
export function getSecLimit(parm) {
  return request({
    url: '/user/userinfo/getseclimit',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户获取免密支付限制额度
export function getIniInfo(parm) {
  return request({
    url: '/user/userinfo/getiniinfo',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户修改免密支付
export function modifySecLimit(parm) {
  return request({
    url: '/user/userinfo/modifyseclimit',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户修改验证方式
export function modifyVerify(parm) {
  return request({
    url: '/user/userinfo/modifyverify',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户修改密码
export function modifyPass(parm) {
  return request({
    url: '/user/userinfo/modifypass',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 用户绑定谷歌验证器
export function bindGoogle(parm) {
  return request({
    url: '/user/userinfo/bindgoogle',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 实名认证
export function realCheck(parm) {
  return request({
    url: '/user/userextinfo/realcheck',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
// 查看自己绑定的谷歌验证器
export function lookGoogle(parm) {
  return request({
    url: '/user/userinfo/lookgoogle',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}
